import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spin, message } from 'antd';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  // 检查账号状态
  useEffect(() => {
    if (!user || loading) return;

    // 检查账号是否被禁用且未到期
    const checkAccountDisabled = () => {
      if (!user.expires_at) return false;
      const now = new Date();
      const expires = new Date(user.expires_at);
      const isExpired = now > expires;
      return !user.is_active && !isExpired;
    };

    if (checkAccountDisabled()) {
      message.error('账号已被禁用，请联系管理员');
      setTimeout(() => {
        logout();
        navigate('/login');
      }, 2000);
    }
  }, [user, loading, logout, navigate]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;

